import {message, Switch} from "antd";
import {SActionBtn, SLowcodeList, SMessage, STableActions} from "shj-components";
import {config} from "./config.tsx";
import EditContent from "./edit.tsx";
import {useSetState} from "ahooks";
import {tableApiFunc} from "@/utils/data.ts";
import {deleteMemberTask, memberTaskUpdateState, queryMemberTaskListByPage} from "@/services/member.ts";
import {useRef} from "react";

const taskTypeList = [{label: '每日任务', value: 'daily'}, {label: '新手任务', value: 'newbie'}]
const stateTypeList = [{label: '启用', value: true}, {label: '停用', value: false}]

/**
 *
 * 任务配置
 * @constructor
 */
function Page() {

    const [state, setState] = useSetState({open: false, data: null});

    const tableRef = useRef<any>()

    const onChangeStatus = (checked, id) => {
        SMessage.confirm({
            title: checked ? '启用操作' : '禁用操作',
            content: `确定继续操作吗？`,
            onOk: async () => {
                try {
                    await memberTaskUpdateState({id, state: checked})
                    tableRef.current.reload()
                } catch (e) {
                    console.log(e)
                }
            },
        })
    }

    const onAddOrEdit = (data?: any) => {
        setState({open: true, data: data});
    }
    const onDelete = (id: string) => {
        deleteMemberTask({id}).then(() => {
            message.success('删除成功');
            tableRef.current.reload();
        })
    }
    const destroy=(success:boolean)=>{
        setState({open: false, data: null})
        if (success) {
            tableRef.current.reload();
        }
    }

    const getStatusOptions = async () => {
        return Promise.resolve({
            taskTypeList,
            stateTypeList
        })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(queryMemberTaskListByPage, {
                paginationInBody: true,
                fieldNames: {current: 'current'},
            }),
            getStatusOptions,
        },
        events: {onAdd: () => onAddOrEdit()},
        customRender: {
            switchRender(v: boolean, record: Record<string, any>) {
                return <Switch checked={v} onClick={(checked) => onChangeStatus(checked, record.id)}/>
            },
            actionRender(_: null, record: Record<string, any>) {
                return (
                    <STableActions>
                        <SActionBtn disabled={record.state} onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
                        <SActionBtn disabled={record.state} isDelete onClick={()=>onDelete(record.id)}>删除</SActionBtn>
                    </STableActions>
                )
            }
        }
    }
    return (
        <div>
            <div style={{display: 'flex'}}>
                <EditContent {...state} typeList={taskTypeList} destroy={destroy}/>
                <SLowcodeList
                    searchMode={'group'}
                    config={config}
                    {...extensions}
                    ref={tableRef}
                />
            </div>
        </div>
    );
}

export default Page;
